// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"31":"b2c88122","181":"e962332c","394":"f759f93c","459":"b2c88122","621":"8f861456"}[chunkId] + ".css";
};